import { Paper } from "@mantine/core";
import { Headers } from "../components/ui/heading";
import Navigation from "../components/MyAccount/Navigation";

function MyAccount() {
  return (
    <div className="min-h-screen flex flex-col pb-16">
      <Paper shadow="xs" p={{ base: "sm", sm: "xl" }}>
        <div className="mb-2 sm:mb-4 flex-shrink-0">
          <Headers name="My Account" />
        </div>
        <div className="flex-1">
          <Navigation />
        </div>
      </Paper>
    </div>
  );
}

export default MyAccount;
